<template>
  <div class="home__showcase" id="homeShowcase">
    <video
      class="hero-video"
      autoplay
      muted
      loop
      playsinline
      preload="auto"
      :src="videoSrc"
    ></video>

    <div class="left">
      <div class="logo--mobile">
        <img src="@/assets/img/logo.svg" alt="3V-Rentgen" />
      </div>
      <div class="texts">
        <h1>Издигнете денталното си ниво</h1>
        <h1>с <strong>МДЛ 3В-Рентген</strong></h1>

        <p>
          Рентгенографии, Ортопантомографии (панорамни) на зъби, <br />
          Телерентгенографии и Компютърна томография (CBCT 3D)
        </p>

        <Button
          @click="$emit('open-app')"
          class="button--bigger round button--width blue"
        >
          <transition name="slide-left" mode="out-in">
            <span>ВХОД - ОНЛАЙН РЕЗУЛТАТИ</span>
          </transition>
        </Button>
      </div>
      <ul class="steps" :class="{ 'steps--animate': animateSteps }">
        <li class="step">
          <span class="step__number">1</span>
          <img class="step__image" src="@/assets/img/home/1.png" alt="" />
          <div class="step__texts">
            <h2 class="step__title">Снимка</h2>
            <p class="step__subtitle">от 4.1 до 7.0 секунди</p>
          </div>
        </li>
        <li class="step">
          <span class="step__number">2</span>
          <img
            class="step__image step__image--dental"
            src="@/assets/img/home/2.png"
            alt=""
          />
          <div class="step__texts">
            <h2 class="step__title">Резултат</h2>
            <p class="step__subtitle">от 3 до 5 минути</p>
          </div>
        </li>
        <li class="step">
          <span class="step__number">3</span>
          <img
            class="step__image step__image--stats"
            src="@/assets/img/home/3.png"
            alt=""
          />
          <div class="step__texts">
            <h2 class="step__title">е-Картон</h2>
            <p class="step__subtitle">с история на пациента</p>
          </div>
        </li>
        <Button
          @click="$emit('goToSection', 'homeServices')"
          class="button--bigger round button--width blue-border"
        >
          <transition name="slide-left" mode="out-in">
            <span>ВИЖ НАШИТЕ УСЛУГИ И ЦЕНИ</span>
          </transition>
        </Button>
      </ul>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
export default {
  components: {
    Button,
  },
  computed: {
    videoSrc() {
      return this.isMobile
        ? require("@/assets/img/home/video-m.mp4")
        : require("@/assets/img/home/video-d.mp4");
    },
  },
  data() {
    return {
      animateSteps: false,
      isMobile: false,
    };
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
  mounted() {
    this.checkIsMobile();
    window.addEventListener("resize", this.checkIsMobile, { passive: true });

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.animateSteps = true;
      });
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkIsMobile);
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/variables.scss";
@import "@/scss/mixins.scss";
.home__showcase {
  display: flex;
  color: #223432;
  font-family: "Roboto";
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  min-height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);
  padding-top: 200px;
  position: relative;

  &::before {
    content: "";
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.55) 0%,
      rgba(255, 255, 255, 0.55) 25%,
      rgba(255, 255, 255, 0.35) 45%,
      rgba(255, 255, 255, 0.25) 65%,
      rgba(255, 255, 255, 0) 85%
    );
    position: absolute;
    pointer-events: none;
    inset: 0;
    z-index: 1;
  }
}

.hero-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.left {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0 20px 0 150px;
  position: relative;
  z-index: 2;
  width: 100%;

  > .texts {
    width: 65%;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    h1 {
      font-size: 3.5rem;
      font-weight: 300;
      line-height: 4rem;

      strong {
        font-size: 3.8rem;
        font-weight: 600;
      }
    }
    p {
      font-family: "Roboto Condensed", sans-serif;
      font-size: 1.5rem;
      color: #0077c7;
    }
  }
}
.steps {
  display: flex;
  align-items: flex-end;
  gap: 30px;
  margin-top: 40px;
  width: 100%;
  --step-size: clamp(140px, 16vw, 200px);

  &.steps--animate {
    .step {
      animation: step-rise 1300ms cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
      animation-delay: var(--step-delay);
    }

    .step__number,
    .step__texts {
      animation: step-rise 1120ms cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
      animation-delay: calc(var(--step-delay) + var(--part-delay));
    }

    .step__image {
      animation: image-fade 900ms cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
      animation-delay: calc(var(--step-delay) + var(--part-delay));
    }
  }

  @keyframes step-rise {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes image-fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .step {
    border-radius: 50%;
    background: rgba(42, 85, 132, 0.8);
    backdrop-filter: blur(30px);
    color: #fff;
    display: flex;
    flex-direction: column;
    height: var(--step-size);
    transform: translateY(30%);
    position: relative;
    padding: clamp(10px, 1.5vw, 20px) clamp(18px, 3vw, 35px);
    opacity: 0;
    width: var(--step-size);

    .step__number,
    .step__image,
    .step__texts {
      opacity: 0;

      &.step__number,
      &.step__texts {
        transform: translateY(50%);
      }
    }
  }

  .step:nth-child(1) {
    --step-delay: 0ms;
  }
  .step:nth-child(2) {
    --step-delay: 360ms;
  }
  .step:nth-child(3) {
    --step-delay: 540ms;
  }

  .step__number {
    --part-delay: 600ms;
  }
  .step__image {
    --part-delay: 1200ms;
  }
  .step__texts {
    --part-delay: 1000ms;
  }

  .step__number {
    font-size: clamp(2.6rem, 10vw, 5.5rem);
    font-weight: 100;
    flex-basis: 60%;
    text-align: left;
  }

  .step__image {
    position: absolute;
    top: 40%;
    transform: translateY(-50%);
    max-width: 75%;
    height: auto;
    object-fit: contain;
    right: calc(var(--step-size) * -0.2);

    &.step__image--dental {
      top: 30%;
      max-width: 60%;
      right: calc(var(--step-size) * -0.05);
    }

    &.step__image--stats {
      max-width: 80%;
      right: calc(var(--step-size) * -0.15);
      top: 30%;
    }
  }

  .step__texts {
    display: block;
    align-self: center;
    width: 100%;

    .step__title {
      opacity: 0.5;
    }

    .step__title {
      font-size: clamp(1rem, 2vw, 1.5rem);
    }
    .step__subtitle {
      font-size: clamp(0.65rem, 1.3vw, 0.9rem);
    }
  }

  .button {
    align-self: center;
    margin-left: auto;
  }
}

.logo--mobile,
.texts .button {
  display: none;
}

@media screen and (max-width: $xl) {
  .left {
    > .texts {
      h1 {
        font-size: 3rem;
        line-height: 3rem;
      }
      p {
        font-size: 1.3rem;
      }
    }
  }
  .steps {
    display: flex;
    li {
      > p {
        align-items: center;
        display: inline-flex;
        font-size: 3rem;
        font-weight: 100;
        .icon {
          margin: 0 -0.5rem 0 -1rem;
          font-size: 3rem;
        }
      }
      .texts {
        h1 {
          font-size: 2rem;
        }
        p {
          font-size: 1.2rem;
        }
      }
    }
  }
}

@media screen and (max-width: $sm) {
  .home__showcase {
    padding: 0;
    .hero-video {
      top: -20%;
    }

    &::before {
      content: "";
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0.85) 30%,
        rgba(255, 255, 255, 0.4) 60%,
        rgba(255, 255, 255, 0) 100%
      );
      backdrop-filter: blur(12px);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 35%;
      pointer-events: none;
      z-index: 1;
    }

    &::after {
      content: "";
      background: linear-gradient(
        to top,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0.8) 40%,
        rgba(255, 255, 255, 0) 100%
      );
      bottom: 5%;
      left: 0;
      right: 0;
      height: 30%;
      position: absolute;
      pointer-events: none;
      z-index: 1;
    }
  }
  .logo--mobile {
    align-items: center;
    display: flex;
    height: 100px;
    justify-content: center;
    width: 100%;
    img {
      height: 100%;
    }
  }
  .left {
    align-items: center;
    padding: 50px 65px;
    text-align: center;
    width: 100%;
    > .texts {
      width: 100%;
      h1 {
        font-size: 2rem;
        line-height: 2rem;

        strong {
        font-size: 2.3rem;
        }
      }
      p {
        font-size: 1.2rem;
        width: 100%;
      }
    }
  }
  .steps {
    justify-content: center;
    gap: 16px;
    margin-top: initial;
    .button {
      display: none;
    }

    .step {
      width: clamp(110px, 30vw, 160px);
      height: clamp(110px, 30vw, 160px);
    }
  }
  .texts .button {
    display: flex;
    margin: 0 auto;
  }
}
@media screen and (max-width: $s) {
  .logo--mobile {
    top: 0;
    left: 0;
    height: 100px;
    position: absolute;
    img {
      height: 80px;
    }
  }
  .left {
    align-items: center;
    height: 100%;
    justify-content: space-between;
    padding: 100px 20px $sm-nav-height;
    width: 100%;
    > .texts {
      text-align: center;
    }
  }

  .steps {
    .step {
      .step__texts {
        .step__title {
          text-align: left;
        }
      }
    }
  }
}
@media screen and (max-width: $xs) {
  .left {
    > .texts {
      h1 {
        font-size: 1.5rem;
        line-height: 1.5rem;
      }
      p {
        font-size: 1rem;
      }
    }
  }
}
</style>
